import util from '../lib/util';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
class Docket extends Base implements EntityType {
    docketId: uuid;
    name: string;
    description?: string | null;
    courtId?: uuid | null;
    startTime?: Date | null;
    endTime?: Date | null;
    roomNumber?: string | null;
    constructor(doc: typeof Docket | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            docketId: genUUID(),
            name: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "docket";
        // @ts-ignore
        this.docketId = doc._docketId || doc.docketId || doc.docketid || genUUID();
        // @ts-ignore
        this.name = doc._name || doc.name || null;
        // @ts-ignore
        this.description = doc._description || doc.description || null;
        // @ts-ignore
        this.courtId = doc._courtId || doc.courtId || doc.courtid || null;
        // @ts-ignore
        this.startTime = doc._startTime || doc.startTime || doc.starttime || null;
        // @ts-ignore
        this.endTime = doc._endTime || doc.endTime || doc.endtime || null;
        // @ts-ignore
        this.roomNumber = doc._roomNumber || doc.roomNumber || doc.roomnumber || null;
    }
    get id(): uuid { return this.docketId; }
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique ID for a docket"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.docketId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Docket[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'docket',
    dataArea: 'Calendar',
    table: 'DOCKET',
    comment: 'A court docket represents a scheduled hearing slot at a specific court, with a defined start time, end time, and room number. Dockets are configured firm-wide and assigned to tasks, grouping court-related work (hearings, filings, appearances) under a named court session for calendaring purposes.',
    fields: {
        docketId: {
            type: 'uuid', required: true, pk: true, default: '__UUID__', comment: 'Unique ID for a docket'
        },
        name: {
            type: 'string', required: true, comment: 'The name of the docket'
        },
        description: {
            type: 'string', comment: 'Short description of the docket'
        },

        courtId: {
            type: 'uuid', entityType: 'court', comment: 'Associated court for this docket'
        },

        startTime: {
            type: 'time', comment: 'Time that the docket starts'
        },

        endTime: {
            type: 'time', comment: 'Time that the docket ends'
        },

        roomNumber: {
            type: 'string', comment: 'Default room number (if constant)'
        }
    },
    maps: [
        {
            name: 'courtId',
            keysFn: s => s.courtId,
            presentFn: (s, k) => s.courtId === k && s.status !== 'D'
        }
    ]
});
    }
}
export default Docket;
